// メールアドレス重複チェック
export async function emailExists(email){
    const response = await fetch('/system/user/common/user-db-email-check.php',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({email:email})
    });
    const result = await response.json();
    if(result.success){
        return true;
    }else{
        return false;
    }
}